import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: '/public-api',
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Accept-Language': document.documentElement.lang || 'de'
    }
});

export default {
    install: (app) => {
        app.config.globalProperties.$axios = axiosInstance;
        app.provide('axios', axiosInstance);
    }
};

export { axiosInstance as axios };
